import * as FlatModels from '@medsurf/flat-models';

// <editor-fold desc="Store">

/**
 * Get Entity Success
 */
export abstract class GetEntitySuccess {
  public constructor(public entityQueryResult: FlatModels.EntityControlModels.EntityQueryResult) {
  }
}

/**
 * Get Entities Success
 */
export abstract class GetEntitiesSuccess {
  public constructor(public entityQueryResults: FlatModels.EntityControlModels.EntityQueryResult[]) {
  }
}

export abstract class ModifyEntitySuccess {
  public constructor(public saveSnapshotItem: FlatModels.EntityControlModels.SaveSnapshotItem) {
  }
}

export abstract class ModifyEntitiesSuccess {
  public constructor(public saveSnapshotItems: FlatModels.EntityControlModels.SaveSnapshotItem[]) {
  }
}

/**
 * Add Entity
 */
export abstract class AddEntity<T extends FlatModels.Base | FlatModels.UserEntityModels.User> {
  public constructor(public entity: T) {
  }
}

/**
 * Update Entity
 */
export abstract class UpdateEntity<T extends FlatModels.Base | FlatModels.UserEntityModels.User> {
  public constructor(public entity: T) {
  }
}

/**
 * Remove Entity
 */
export abstract class RemoveEntity<T extends FlatModels.Base | FlatModels.UserEntityModels.User> {
  public constructor(public entity: T) {
  }
}

/**
 * Remove Entities
 */
export abstract class RemoveEntities<T extends FlatModels.Base | FlatModels.UserEntityModels.User> {
  public constructor(public entities: T[]) {
  }
}

/**
 * Undo Snapshot
 */
export abstract class UndoSnapshot {
  public constructor(public snapshotItem: FlatModels.EntityControlModels.HistorySnapshotItem) {
  }
}

/**
 * Redo Snapshot
 */
export abstract class RedoSnapshot {
  public constructor(public snapshotItem: FlatModels.EntityControlModels.HistorySnapshotItem) {
  }
}

/**
 * Clean Up Snapshot
 */
export abstract class CleanUpSnapshots {
  public constructor(public snapshotIds: string[]) {
  }
}

// </editor-fold>